import apiClient from './apiClient';

// user.js
export const registerUser = (user) => {
  return apiClient.post('/register', user);
};

export const loginUser = (user) => {
  return apiClient.post('/login', user);
};

export const getUsers = (params) => {
  return apiClient.get('/user', { params })
    .then(response => ({
      data: {
        items: response.data.rows,
        total: response.data.count
      }
    }));
}

export const createUser = (data) => {
  return apiClient.post('/user', data)
}

export const updateUser = (id, data) => {
  return apiClient.put(`/user/${id}`, data)
}

export const deleteUser = (id) => {
  return apiClient.delete(`/user/${id}`)
}

export const rechargeUser = (id, amount) => {
  return apiClient.post(`/user/${id}/recharge`, { amount })
}

export const depositUser = (id, amount) => {
  return apiClient.post(`/user/${id}/deposit`, { amount })
}

export const updateInterestRate = (id, rate) => {
  return apiClient.put(`/user/${id}/interest-rate`, { rate })
}
